import { baseApi } from '@api/baseApi';
import { ImportProcessInfo } from '@api/import/types/ImportProcessInfo';



const importApi = baseApi.injectEndpoints({
	overrideExisting: false,
	endpoints: (builder) => ({

		//#region "Salesman import"
		salesmanImport: builder.mutation<boolean,FormData>({
			query: (file) => ({
				url: `Import/SalesmanImport`,
				method: 'POST',
				body: file,
			}),
		}),

		getSalesmanImportInfo: builder.query<ImportProcessInfo, void>({
			query: () => ({
				url: `Import/GetSalesmanImportInfo`,
			}),
			keepUnusedDataFor: 0,
		}),

		cancelSalesmanImport: builder.query<boolean, void>({
			query: () => ({
				url: `Import/CancelSalesmanImport`,
			}),
			keepUnusedDataFor: 0,
		}),
		//#endregion

		//#region "Telesales import"
		telesalesImport: builder.mutation<boolean,FormData>({
			query: (file) => ({
				url: `Import/TelesalesImport`,
				method: 'POST',
				body: file,
			}),
		}),

		getTelesalesImportInfo: builder.query<ImportProcessInfo, void>({
			query: () => ({
				url: `Import/GetTelesalesImportInfo`,
			}),
			keepUnusedDataFor: 0,
		}),

		cancelTelesalesImport: builder.query<boolean, void>({
			query: () => ({
				url: `Import/CancelTelesalesImport`,
			}),
			keepUnusedDataFor: 0,
		}),
		//#endregion

		//#region "Merchant import"
		merchantImport: builder.mutation<boolean,FormData>({
			query: (file) => ({
				url: `Import/MerchantImport`,
				method: 'POST',
				body: file,
			}),
		}),

		getMerchantImportInfo: builder.query<ImportProcessInfo, void>({
			query: () => ({
				url: `Import/GetMerchantImportInfo`,
			}),
			keepUnusedDataFor: 0,
		}),

		cancelMerchantImport: builder.query<boolean, void>({
			query: () => ({
				url: `Import/CancelMerchantImport`,
			}),
			keepUnusedDataFor: 0,
		}),
		//#endregion

		//#region "Region Manager import"
		regionManagerImport: builder.mutation<boolean,FormData>({
			query: (file) => ({
				url: `Import/RegionManagerImport`,
				method: 'POST',
				body: file,
			}),
		}),

		getRegionManagerImportInfo: builder.query<ImportProcessInfo, void>({
			query: () => ({
				url: `Import/GetRegionManagerImportInfo`,
			}),
			keepUnusedDataFor: 0,
		}),

		cancelRegionManagerImport: builder.query<boolean, void>({
			query: () => ({
				url: `Import/CancelRegionManagerImport`,
			}),
			keepUnusedDataFor: 0,
		}),
		//#endregion

		//#region "Location Manager import"
		locationManagerImport: builder.mutation<boolean,FormData>({
			query: (file) => ({
				url: `Import/LocationManagerImport`,
				method: 'POST',
				body: file,
			}),
		}),

		getLocationManagerImportInfo: builder.query<ImportProcessInfo, void>({
			query: () => ({
				url: `Import/GetLocationManagerImportInfo`,
			}),
			keepUnusedDataFor: 0,
		}),

		cancelLocationManagerImport: builder.query<boolean, void>({
			query: () => ({
				url: `Import/CancelLocationManagerImport`,
			}),
			keepUnusedDataFor: 0,
		}),
		//#endregion
	}),
});


export const {
	useSalesmanImportMutation,
	useGetSalesmanImportInfoQuery,
	useCancelSalesmanImportQuery,

	useTelesalesImportMutation,
	useGetTelesalesImportInfoQuery,
	useCancelTelesalesImportQuery,

	useMerchantImportMutation,
	useGetMerchantImportInfoQuery,
	useCancelMerchantImportQuery,
	
	useRegionManagerImportMutation,
	useGetRegionManagerImportInfoQuery,
	useCancelRegionManagerImportQuery,

	useLocationManagerImportMutation,
	useGetLocationManagerImportInfoQuery,
	useCancelLocationManagerImportQuery } = importApi;